import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "columns"
};
var _hoisted_2 = {
  class: "column is-6 is-paddingless-top is-paddingless-down"
};
var _hoisted_3 = {
  class: "column is-6 is-paddingless-top is-paddingless-down"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_select_person_status = _resolveComponent("select-person-status");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_input = _resolveComponent("el-input");

  var _component_SelectLanguages = _resolveComponent("SelectLanguages");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_SelectCountry = _resolveComponent("SelectCountry");

  var _component_MazPhoneNumberInput = _resolveComponent("MazPhoneNumberInput");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createBlock(_component_el_form, {
    ref: "form",
    model: _ctx.ruleForm,
    rules: _ctx.rules,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "create-customer-form"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
        prop: "title",
        label: _ctx.$t('customer.person-status')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_select_person_status, {
            class: "is-full-width",
            modelValue: _ctx.ruleForm.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.ruleForm.title = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "firstName",
        label: _ctx.$t('customer.first-name')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _ctx.ruleForm.firstName = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "lastName",
        label: _ctx.$t('customer.last-name')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.ruleForm.lastName = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "email",
        label: _ctx.$t('customer.email')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return _ctx.ruleForm.email = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "languageId",
        label: _ctx.$t('customer.language')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_SelectLanguages, {
            class: "is-full-width",
            modelValue: _ctx.ruleForm.language,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return _ctx.ruleForm.language = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "birthdate",
        label: _ctx.$t('customer.birthdate'),
        size: "large",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_date_picker, {
            modelValue: _ctx.ruleForm.birthDate,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return _ctx.ruleForm.birthDate = $event;
            }),
            "value-format": "YYYY-MM-DD",
            format: "YYYY-MM-DD",
            type: "date",
            placeholder: _ctx.$t('customer.birthdate-placeholder'),
            class: "w-100 birthday-btn"
          }, null, 8, ["modelValue", "placeholder"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "emailMarketingOrganiser",
        label: _ctx.$t('customer.email-marketing-organiser'),
        size: "large"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: _ctx.ruleForm.emailMarketingOrganiser,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return _ctx.ruleForm.emailMarketingOrganiser = $event;
            }),
            placeholder: _ctx.$t('button.select'),
            class: "w-100"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GET_YES_NO_CONTENT, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])];
        }),
        _: 1
      }, 8, ["label"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
        prop: "allergies",
        label: _ctx.$t('customer.allergies')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.allergies,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return _ctx.ruleForm.allergies = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "address",
        label: _ctx.$t('customer.address')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.address,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return _ctx.ruleForm.address = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "zipCode",
        label: _ctx.$t('customer.zip')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.zipCode,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
              return _ctx.ruleForm.zipCode = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "city",
        label: _ctx.$t('customer.city')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.city,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
              return _ctx.ruleForm.city = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "country",
        label: _ctx.$t('customer.country')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_SelectCountry, {
            class: "is-full-width",
            modelValue: _ctx.ruleForm.country,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
              return _ctx.ruleForm.country = $event;
            }),
            filterable: ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "company",
        label: _ctx.$t('customer.company')
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.company,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
              return _ctx.ruleForm.company = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        prop: "phone",
        label: _ctx.$t('columns.phone-number'),
        size: "large"
      }, {
        default: _withCtx(function () {
          var _ctx$results;

          return [_createVNode(_component_MazPhoneNumberInput, {
            modelValue: _ctx.ruleForm.phone,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
              return _ctx.ruleForm.phone = $event;
            }),
            color: "info",
            "show-code-on-list": "",
            "default-country-code": _ctx.ruleForm.country,
            "list-position": "top left",
            onUpdate: _cache[14] || (_cache[14] = function ($event) {
              return _ctx.results = $event;
            }),
            success: (_ctx$results = _ctx.results) === null || _ctx$results === void 0 ? void 0 : _ctx$results.isValid,
            size: "md",
            translations: {
              countrySelector: {
                placeholder: _ctx.$t('phone-input.country-code'),
                error: _ctx.$t('phone-input.choose-country')
              },
              phoneInput: {
                placeholder: _ctx.$t('columns.phone-number'),
                example: "".concat(_ctx.$t('phone-input.example'), ": ")
              }
            }
          }, null, 8, ["modelValue", "default-country-code", "success", "translations"])];
        }),
        _: 1
      }, 8, ["label"])])])];
    }),
    _: 1
  }, 8, ["model", "rules"]);
}